"use client"
import { useSearchParams } from "next/navigation"

const useQuery = () => {
  const searchParams = useSearchParams()

  const updateQuery = (
    obj: Record<string, string | number | boolean | null | string[]>,
  ) => {
    const params = new URLSearchParams(searchParams?.toString() || "")

    Object.entries(obj).forEach(([key, value]) => {
      if (value === null) {
        params.delete(key)
      } else if (Array.isArray(value)) {
        if (value.length === 0) {
          params.delete(key)
        } else {
          params.delete(key)
          value.forEach((val) => {
            params.append(key, `${val}`)
          })
        }
      } else {
        params.set(key, `${value}`)
      }
    })

    window.history.replaceState(null, "", `?${params.toString()}`)
  }

  return { searchParams, updateQuery }
}

export default useQuery
